
import api from '~/api/' // server

export default {
    name: 'DetailListUnderViewWithAnswer',
    props: {
        params: {
            type: Object,
            default() {
                return {}
            },
        },
        subtitleName: {
            type: String,
            default: '제목',
        },
        subcontentName: {
            type: String,
            default: '내용',
        },
    },
    data() {
        return {
            questionDetail: {},
            answerDetail: this.answerDetailInit(),
        }
    },
    watch: {
        params() {
            this.getBoardNoticeDetail()
        },
    },
    created() {
        this.getBoardNoticeDetail()
    },
    methods: {
        async getBoardNoticeDetail() {
            const params = {
                ...this.params,
            }

            const { data } = await api.getNoticeBoardDetail(params)

            // 존재한다면, 답변이 있는 경우
            if (data.newsItem) {
                const items = data.newsItem
                // flag = 1 일때, 사용자 질문
                if (items[0].flag === 1) {
                    this.questionDetail = { ...items[0] }
                    this.answerDetail = { ...items[1] }
                } else {
                    this.questionDetail = { ...items[1] }
                    this.answerDetail = { ...items[0] }
                }

                return
            }

            // 답변이 존재하지 않는 경우
            this.questionDetail = data
            this.questionDetail.content = this.questionDetail.content.replaceAll('\n', '<br>')
            this.answerDetail = this.answerDetailInit()
        },
        onClickBackToList() {
            this.$emit('backToList')
        },
        answerDetailInit() {
            return undefined
        },
    },
}
